var module = angular.module('octopusApp.projects');

module.directive('applicationPoolEditor', function(octopusRepository, sensitiveValue) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      action: '=',
      project: '=',
      localNames: '=',
      pathToRootProperty: '@'
    },
    templateUrl: 'areas/projects/views/application_pool_editor.html',
    link: function(scope, element) {
        scope.fullPath = function(propertyName){
            return scope.pathToRootProperty + "." + propertyName;
        };

        scope.identity = {
            identityTypeBound: {},
            applicationPoolPasswordResetValue: sensitiveValue.getResetValue(scope.action.Properties[scope.fullPath("ApplicationPoolPassword")])
        };
     }
 };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/application_pool_editor.js
// module id = 537
// module chunks = 1